<!-- Button -->
<div class="relative">
    <button mat-button>
        <div class="flex flex-row items-center justify-center gap-2">
            <img *ngIf="currentUser !== null" [src]="'assets/icons/flags/' + currentUser.Country_Name.toLowerCase() + '.png'">
            <span class="font-sans" [appDynamicStyles]="{'font-size' : { zoomout: '14px', zoomin: '13px' }}">{{ currentUser !== null ? currentUser.Country_Name : ''}}</span>
        </div>
    </button>
</div>
